/**************************************
 *            ~=TODOs=~
 * [ ] - review revisions
 * [ ] - syndicated review
 * [ ] - tracked topics
 *************************************/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from "mobx-react";
import moment from 'moment';
import classnames from 'classnames';
import providersStore from '../../../services/providers/ProvidersStore';

import {PublishingStatus} from '../models';
import {Recommended, SocialImage, Stars} from '../../../components/index';

import ReviewData from './ReviewData';
import ReviewName from './ReviewName';
import ReviewResponse from './ReviewResponse';
import {Markup} from "../../../components/text/Markup";

const ReviewSummary = observer(class ReviewSummary extends Component {
  static propTypes = {
    review: PropTypes.object.isRequired,
    showResponses: PropTypes.bool,
    showPublishingErrors: PropTypes.bool,
    updateResponse: PropTypes.func,
    rejectResponse: PropTypes.func,
    removeResponse: PropTypes.func,
    textToHighlight: PropTypes.string
  };

  static defaultProps = {
    showResponses: true,
    showPublishingErrors: false
  };

  constructor(props){
    super(props);
    this.reviewDate = moment(props.review.reviewDate);
  }

  reviewDiff(){
    const {review} = this.props;

    if(review.lastRevisionDate && moment.utc(review.reviewDate).diff(moment.utc(review.lastRevisionDate.$date))){
      return <span className="border border-gray font-italic ml-4 px-2 py-1 rounded">Updated {moment.utc(review.lastRevisionDate.$date).format('MM/DD/YY')}</span>
    }
  }

  render() {
    const {review, showResponses, showPublishingErrors} = this.props;
    let starsOrRecommend;
    if(typeof review.recommended !== 'undefined'){
      starsOrRecommend = <Recommended doesRecommend={review.recommended}/>
    }else if(review.roundedRating){
      starsOrRecommend = <Stars rating={review.roundedRating} id={review.reviewId} />;
    }else if(review.rating){
      starsOrRecommend = <Stars rating={Math.round(review.rating)} id={review.reviewId} />;
    }
    // TODO - show error responses with error badge like existing reviews tab.
    // Maybe show some other features
    const responses = showResponses ? review.responses.filter(r => r)
      .filter(response => showPublishingErrors ? true : response.publishingStatus !== PublishingStatus.ERROR) : [];

    return (
      <div className="cm-review clearfix d-flex align-items-stretch my-0 py-0">
        <div className="review-column-provider truncate">
          <a href={review.reviewURL} target="_blank">
            <SocialImage userImage={review.reviewerPictureURL} provider={review.contentProvider} providers={providersStore.providers} />
            <br/>
            {providersStore.displayNameFor(review.contentProvider)}
          </a>
        </div>
        <div className="w-100">
          <div className="cm-review-details">
            <div className="row">
              <div className="col-xs-6 col-sm-6 review-detail">
                {starsOrRecommend}
                <span className="cm-review-date text-gray">
                  {this.reviewDate.format('MM/DD/YY')}{this.reviewDiff()}
                </span>
              </div>
            </div>
            <div className="review-data row d-flex">
              <div className="col-12 review-detail cm-review-details">
                { !!this.props.textToHighlight ?
                  <Markup textToMarkup={review.reviewDetail} searchPhrases={[{
                    phrase: this.props.textToHighlight,
                    markupClassName: "highlight-area"
                  }]}/> : review.reviewDetail
                }
                <ReviewData reviewId={review.reviewId} reviewData={review.reviewData} />
              </div>
              <div className="col-12 review-detail cm-review-user">
                <ReviewName name={review.reviewerUserName} />
              </div>
            </div>
          </div>
          <div className="col-12">
            {responses.map((response, index) => (
              <ReviewResponse className={classnames({ disabled: index !== responses.length - 1 && ![PublishingStatus.ERROR,  PublishingStatus.UNHANDLED_ERROR, PublishingStatus.AWAITING_APPROVAL].includes(response.publishingStatus)})}
                              key={response._id.$oid}  response={response}
                              updateResponse={this.props.updateResponse}
                              rejectResponse={this.props.rejectResponse}
                              removeResponse={this.props.removeResponse}
              />))
            }
          </div>
        </div>
      </div>
    )
  }
});

export default ReviewSummary;
